const apikeymap={
    apikey:"AIzaSyBZhVJe_699r0rwfycOumQAD9unFlal_2g"
}

export default apikeymap